export default {
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
  TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY || "token_key",
  GOOGLE_TOKEN_KEY: process.env.REACT_APP_GOOGLE_TOKEN_KEY || "google_token_key",
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api",
};
